import "./previous-day-pickup.scss";

import { observer } from "mobx-react-lite";
import { useEffect } from "react";

import { ReactComponent as PickupsTruck } from "@client/components/reusable/SvgIcons/library/pickups-truck.svg";
import { useRootContext } from "@client/context/RootContext";

export const PreviousDayPickup = observer(() => {
	const { vendorStore, modalStore } = useRootContext();

	useEffect(() => {
		if (vendorStore.show_previous_day_courier) {
			const id = "previous-day-pickup";
			modalStore.addModal({
				id,
				content: <PreviousDayPickupModal />,
				closeOnBackdropClick: false,
			});
		}
	}, [vendorStore.show_previous_day_courier]);

	return null;
});

function PreviousDayPickupModal() {
	const { vendorStore, modalStore } = useRootContext();

	return (
		<div className={"previous-day-pickup-wrapper"}>
			<PickupsTruck width={48} height={48} />

			<div className="previous-day-pickup-title">
				האם ביום העסקים הקודם, הגיע אליכם שליח לאיסוף?
			</div>
			<div className="previous-day-pickup-options">
				<div
					className={"previous-day-pickup-option"}
					onClick={async () => {
						vendorStore.set_show_previous_day_courier(false);

						modalStore.removeModal("previous-day-pickup");

						await vendorStore.PickupsOperations.previous_day_courier("no");
					}}
				>
					לא
				</div>
				<div
					className={"previous-day-pickup-option"}
					onClick={async () => {
						vendorStore.set_show_previous_day_courier(false);

						modalStore.removeModal("previous-day-pickup");

						await vendorStore.PickupsOperations.previous_day_courier("yes");
					}}
				>
					כן
				</div>
			</div>
		</div>
	);
}
